<template>
  <div v-if="loaded" id="mobile-logged-in">
    <i id="logo" />
    <div class="content-section">
      <div class="go-to-account section">
        <h2>{{ label.get("go_to_account") }}</h2>
        <p
          v-html="label.get('mobile_component_access_your_account_description')"
        />
        <a :href="openAppUrl" target="_blank" class="atto-btn submit">{{
          label.get("open_app")
        }}</a>
      </div>
      <hr />
      <div v-if="isOwner" class="access-billing section">
        <h2>{{ label.get("access_billing") }}</h2>
        <p v-html="label.get('mobile_component_account_billing_description')" />
        <a href="/settings/subscription" class="atto-btn submit">{{
          label.get("go_to_billing")
        }}</a>
      </div>
    </div>
    <a href="/logout" class="log-out">{{ label.get("log_out") }}</a>
  </div>
</template>

<script>
import UtilsService from "../../shared/services/UtilsService";

export default {
  name: "MobileComponent",
  computed: {
    loaded() {
      const initialLoader = document.getElementById("initial-loader");
      if (initialLoader !== undefined && initialLoader !== null) {
        initialLoader.remove();
      }
      return this.$store.state.loaded;
    },
    isOwner() {
      if (this.$store.state.user !== null) {
        return this.$store.state.user.id === this.$store.state.company.user_id;
      }
      return false;
    },
    openAppUrl() {
      if (UtilsService.isMobile.Android()) {
        return "https://attotime.com/download/android";
      }
      return "https://attotracking.page.link/open-app?q=";
    },
  },
};
</script>

<style lang="scss" scoped>
#mobile-logged-in {
  padding: 4vh 0 7.5vh;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: #ffffff;

  #logo {
    width: 90px;
    display: inline-flex;
    height: 25px;
    background-image: url("~/assets/web/images/atto-logo.svg");
    margin-bottom: 50px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .section {
    margin: 0 auto;
    width: 300px;
    display: inline-flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    h2 {
      font-family: "Roboto", sans-serif;
      font-weight: bold;
      font-size: 1.375rem;
      line-height: 2rem;
      color: #262626;
      margin-bottom: 8px;
    }

    p {
      font-family: "Roboto", sans-serif;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.375rem;
      color: #999;
      margin-bottom: 24px;
    }

    .atto-btn {
      width: 166px;
      padding: 12px 19px;
      text-align: center;
      display: inline-flex;
      font-family: "Roboto", sans-serif;
      font-weight: bold;
      color: #fff;
      font-size: 14px;
      line-height: 24px;
      justify-content: center;
      margin: 0 auto;
      text-transform: uppercase;
    }
  }

  hr {
    width: 60px;
    height: 2px;
    background-color: #efefef;
    margin: 27px auto 20px;
    border: 0;
  }

  .log-out {
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    color: #262626;
    font-size: 16px;
    line-height: 22px;
    margin-top: 50px;
  }
}
</style>
